// @flow
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

type Props = {
    modal: Object
};

type State = {};

/**
 *
 */
class Modal extends PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
    }

    render() {
        const { modal } = this.props;

        return (
            <div>
                {modal && modal.component && (
                    <div className='w-modal' id={modal.id || ''}>
                        {React.createElement(modal.component, modal.props || {})}
                    </div>
                )}
            </div>
        );
    }
}

function _mapStateToProps(state) {
    return {
        modal: state['wildix/features/modal'].modal
    };
}

export default connect(_mapStateToProps, null)(Modal);
